module.exports = __webpack_public_path__ + "img/report02.cd3440ef.png";